import { Component, ElementRef, EventEmitter, Input, Output, QueryList, ViewChildren } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-otp-input',
  templateUrl: './otp-input.component.html',
  styleUrls: ['./otp-input.component.scss']
})
export class OtpInputComponent {
  @Input() length: number = 6; // Default length
  @Input() errorState: boolean = false; // Accept error state from parent

  @Output() otpComplete = new EventEmitter<string>();

  @ViewChildren('otpInput') otpInputs!: QueryList<ElementRef>;

  otpForm: FormGroup;

  constructor() {
    this.otpForm = new FormGroup({});
    for (let i = 0; i < this.length; i++) {
      this.otpForm.addControl(`otp${i}`, new FormControl('', [
        Validators.required,
        Validators.pattern(/^[\u0600-\u06FFa-zA-Z0-9]$/) // Allow Arabic, English, and numbers
      ]));
    }
  }

  ngAfterViewInit(): void {
    this.otpInputs.first.nativeElement.focus();
  }

  handleInput(event: KeyboardEvent, index: number): void {
    const input = event.target as HTMLInputElement;
    const nextInput = this.otpInputs.get(index + 1)?.nativeElement;
    const prevInput = this.otpInputs.get(index - 1)?.nativeElement;
  
    if (input.value.length === 1 && nextInput) {
      nextInput.focus();
    }
  
    if (event.key === 'Backspace' && prevInput && !input.value) {
      prevInput.focus();
    }
  
    this.emitOtp();
  }
  
  handlePaste(event: ClipboardEvent): void {
    event.preventDefault();
    const pastedData = event.clipboardData?.getData('text') || '';
    const trimmed = pastedData.replace(/\s+/g, '');

    if (trimmed.length === this.length && /^[\u0600-\u06FFa-zA-Z0-9]+$/.test(trimmed)) {
      // Fill OTP inputs with pasted values
      const otpArray = trimmed.split('');
      Object.keys(this.otpForm.controls).forEach((key, index) => {
        if (otpArray[index]) {
          this.otpForm.controls[key].setValue(otpArray[index]);
        }
      });

      // Move focus to the last input
      this.otpInputs.last.nativeElement.focus();
      this.emitOtp();
    }
  }

  emitOtp(): void {
    const otpValue = Object.values(this.otpForm.value).join('');
    // if (otpValue.length === this.length) {
    //   this.otpComplete.emit(otpValue); // Emit OTP when complete
    // }
    this.otpComplete.emit(otpValue); // Emit OTP when complete

  }
}
